export default __webpack_public_path__ + "static/media/tree6.a9759686.svg";